import { useCurrentUserId } from './auth'
import useUser from './useUser'

export default function useCurrentUser() {
  return useUser(useCurrentUserId())
}
